import React from 'react';
import styled from 'styled-components';
import roadmap from 'assets/roadmap.svg';

const Wrapper = styled.div`
  margin: -16px;
  background: white;
`;

const Roadmap = () => (
  <Wrapper>
    <img src={roadmap} alt="Operational Intelligence Roadmap" />
  </Wrapper>
);

export default Roadmap;



// WEBPACK FOOTER //
// ./src/components/Roadmap/Roadmap.js